/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from '../../$$_gendir/node_modules/angular-calendar/dist/esm/src/directives/calendarTooltip.directive.ngfactory';
import * as i4 from './components/public/purchase-ticket.ngfactory';
import * as i5 from './components/online-enrolment-view.ngfactory';
import * as i6 from './components/main.ngfactory';
import * as i7 from './components/enrolment-timetable-view.ngfactory';
import * as i8 from './components/workshops-view.ngfactory';
import * as i9 from './components/calendar-view.ngfactory';
import * as i10 from './components/comms-view.ngfactory';
import * as i11 from './components/roles-view.ngfactory';
import * as i12 from './components/admin-area-view.ngfactory';
import * as i13 from './components/class-rollover-view.ngfactory';
import * as i14 from './components/enrolment-rollover-view.ngfactory';
import * as i15 from './components/academic-rollover-view.ngfactory';
import * as i16 from './components/workshops-rollover-view.ngfactory';
import * as i17 from './components/direct-debit-summary-view.ngfactory';
import * as i18 from './components/transactions-by-debtor-view.ngfactory';
import * as i19 from './components/contact-form.ngfactory';
import * as i20 from './components/enquiry-form.ngfactory';
import * as i21 from './components/set-class-form.ngfactory';
import * as i22 from './components/enrolment-form.ngfactory';
import * as i23 from './components/calendar-day-form.ngfactory';
import * as i24 from './components/absence-form.ngfactory';
import * as i25 from './components/workshop-campus-form.ngfactory';
import * as i26 from './components/window-form.ngfactory';
import * as i27 from './components/tutor-allocation-form.ngfactory';
import * as i28 from './components/booking-form.ngfactory';
import * as i29 from './components/workshop-absence-form.ngfactory';
import * as i30 from './components/booking-removal-form.ngfactory';
import * as i31 from './components/set-rollover-form.ngfactory';
import * as i32 from './components/change-class-form.ngfactory';
import * as i33 from './components/disenrolment-form.ngfactory';
import * as i34 from './components/create-transaction-view.ngfactory';
import * as i35 from './components/create-transaction-form.ngfactory';
import * as i36 from './components/add-discount-form.ngfactory';
import * as i37 from './components/ticket-form.ngfactory';
import * as i38 from './app.component.ngfactory';
import * as i39 from '@angular/common';
import * as i40 from '@angular/platform-browser';
import * as i41 from '@angular/animations/browser';
import * as i42 from '@angular/platform-browser/animations';
import * as i43 from '@ngrx/store-devtools/src/extension';
import * as i44 from '@ngrx/store-devtools/src/devtools';
import * as i45 from '@ngrx/store-devtools/src/config';
import * as i46 from '@ngrx/store-devtools/src/instrument';
import * as i47 from '@ngrx/store/src/dispatcher';
import * as i48 from '@ngrx/store/src/reducer';
import * as i49 from '@ngrx/store/src/ng2';
import * as i50 from '@angular/router';
import * as i51 from '@ngrx/effects/src/bootstrap-listener';
import * as i52 from '@ngrx/effects/src/effects-subscription';
import * as i53 from '@angular/forms';
import * as i54 from '@angular/animations';
import * as i55 from 'ng2-completer/services/local-data';
import * as i56 from 'ng2-completer/services/completer-data-factory';
import * as i57 from 'ng2-completer/services/remote-data';
import * as i58 from '@angular/http';
import * as i59 from 'ng2-completer/services/completer-service';
import * as i60 from 'ngx-order-pipe';
import * as i61 from 'angular-draggable-droppable/dist/esm/src/draggable-helper.provider';
import * as i62 from 'angular-calendar/dist/esm/src/providers/calendarEventTitleFormatter.provider';
import * as i63 from 'angular-calendar/dist/esm/src/providers/calendarDateFormatter.provider';
import * as i64 from 'angular-calendar/dist/esm/src/providers/calendarUtils.provider';
import * as i65 from '../../app/services/router-guard';
import * as i66 from 'angular2-token';
import * as i67 from '../../app/constants/helpers';
import * as i68 from '../../app/resolvers/initial';
import * as i69 from '../../app/reducers/effects/constants';
import * as i70 from '@ngrx/store/src/store';
import * as i71 from '../../app/resolvers/contact-view';
import * as i72 from '../../app/reducers/effects/contact';
import * as i73 from '../../app/reducers/effects/matrix-class';
import * as i74 from '../../app/resolvers/enquiry-view';
import * as i75 from '../../app/reducers/effects/enquiry';
import * as i76 from '../../app/resolvers/class-manager-view';
import * as i77 from '../../app/resolvers/class-view';
import * as i78 from '@ngrx/effects/src/actions';
import * as i79 from '../../app/resolvers/enrolment-timetable-view';
import * as i80 from '../../app/resolvers/workshops-view';
import * as i81 from '../../app/resolvers/internal-event-view';
import * as i82 from '../../app/services/event';
import * as i83 from '../../app/resolvers/events-view';
import * as i84 from '../../app/resolvers/event-view';
import * as i85 from '../../app/reducers/effects/event';
import * as i86 from '../../app/reducers/effects/user';
import * as i87 from '../../app/resolvers/roles-view';
import * as i88 from '../../app/reducers/effects/role';
import * as i89 from '../../app/resolvers/calendar-view';
import * as i90 from '../../app/resolvers/online-enrolment-view';
import * as i91 from '../../app/resolvers/direct-debit-summary-view';
import * as i92 from '../../app/resolvers/transactions-by-debtor-view';
import * as i93 from '../../app/resolvers/comms-view';
import * as i94 from '../../app/services/modal';
import * as i95 from '../../app/components/validators/unique-email-async';
import * as i96 from '../../app/services/contact';
import * as i97 from '../../app/components/public/purchase-ticket';
import * as i98 from '../../app/components/online-enrolment-view';
import * as i99 from '../../app/components/main';
import * as i100 from '../../app/components/enrolment-timetable-view';
import * as i101 from '../../app/components/workshops-view';
import * as i102 from '../../app/components/calendar-view';
import * as i103 from '../../app/components/comms-view';
import * as i104 from '../../app/components/roles-view';
import * as i105 from '../../app/components/admin-area-view';
import * as i106 from '../../app/components/class-rollover-view';
import * as i107 from '../../app/components/enrolment-rollover-view';
import * as i108 from '../../app/components/academic-rollover-view';
import * as i109 from '../../app/components/workshops-rollover-view';
import * as i110 from '../../app/components/direct-debit-summary-view';
import * as i111 from '../../app/components/transactions-by-debtor-view';
import * as i112 from '../../app/reducers/combined-reducer';
import * as i113 from '@ngrx/store/src/state';
import * as i114 from '../../app/services/constant';
import * as i115 from '../../app/services/action-cable';
import * as i116 from '../../app/services/role';
import * as i117 from '../../app/services/enrolment';
import * as i118 from '../../app/services/enquiry';
import * as i119 from '../../app/services/matrix-class';
import * as i120 from '../../app/reducers/effects/enrolment';
import * as i121 from '../../app/services/term';
import * as i122 from '../../app/services/public-holiday';
import * as i123 from '../../app/reducers/effects/calendar';
import * as i124 from '../../app/services/workshop';
import * as i125 from '../../app/reducers/effects/workshop';
import * as i126 from '../../app/services/tutor-allocation';
import * as i127 from '../../app/reducers/effects/tutor-allocation';
import * as i128 from '../../app/services/booking';
import * as i129 from '../../app/reducers/effects/booking';
import * as i130 from '../../app/services/ticket';
import * as i131 from '../../app/services/transaction';
import * as i132 from '../../app/reducers/effects/transaction';
import * as i133 from '../../app/services/comm';
import * as i134 from '../../app/reducers/effects/comm';
import * as i135 from '@ngrx/effects/src/effects.module';
import * as i136 from 'angular-resizable-element/dist/esm/src/resizable.module';
import * as i137 from 'angular-draggable-droppable/dist/esm/src/drag-and-drop.module';
import * as i138 from 'angular-calendar/dist/esm/src/calendar.module';
import * as i139 from 'ng2-completer/ng2-completer.module';
import * as i140 from 'angular-date-value-accessor/module';
import * as i141 from 'ng-click-outside/lib/click-outside.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.CalendarTooltipWindowComponentNgFactory,i4.PurchaseTicketComponentNgFactory,
              i5.OnlineEnrolmentViewComponentNgFactory,i6.MainComponentNgFactory,i7.EnrolmentTimetableViewComponentNgFactory,
              i8.WorkshopsViewComponentNgFactory,i9.CalendarViewComponentNgFactory,
              i10.CommsViewComponentNgFactory,i11.RolesViewComponentNgFactory,i12.AdminAreaViewComponentNgFactory,
              i13.ClassRolloverViewComponentNgFactory,i14.EnrolmentRolloverViewComponentNgFactory,
              i15.AcademicRolloverViewComponentNgFactory,i16.WorkshopsRolloverViewComponentNgFactory,
              i17.DirectDebitSummaryViewComponentNgFactory,i18.TransactionsByDebtorViewComponentNgFactory,
              i19.ContactFormComponentNgFactory,i20.EnquiryFormComponentNgFactory,
              i21.SetClassFormComponentNgFactory,i22.EnrolmentFormComponentNgFactory,
              i23.CalendarDayFormComponentNgFactory,i24.AbsenceFormComponentNgFactory,
              i25.WorkshopCampusFormComponentNgFactory,i26.WindowFormComponentNgFactory,
              i27.TutorAllocationFormComponentNgFactory,i28.BookingFormComponentNgFactory,
              i29.WorkshopAbsenceFormComponentNgFactory,i30.BookingRemovalFormComponentNgFactory,
              i31.SetRolloverFormComponentNgFactory,i32.ChangeClassFormComponentNgFactory,
              i33.DisenrolmentFormComponentNgFactory,i34.CreateTransactionViewComponentNgFactory,
              i35.CreateTransactionFormComponentNgFactory,i36.AddDiscountFormComponentNgFactory,
              i37.TicketFormComponentNgFactory,i38.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],
              i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),
          i0.ɵmpd(4608,i39.NgLocalization,i39.NgLocaleLocalization,[i0.LOCALE_ID]),
          i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,
              i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),
          i0.ɵmpd(4608,i40.DomSanitizer,i40.ɵe,[i39.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,
              (null as any),[i40.DomSanitizer]),i0.ɵmpd(4608,i40.HAMMER_GESTURE_CONFIG,
              i40.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,i40.EVENT_MANAGER_PLUGINS,
              (p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i40.ɵDomEventsPlugin(p0_0),new i40.ɵKeyEventsPlugin(p1_0),
                    new i40.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i39.DOCUMENT,i39.DOCUMENT,i39.DOCUMENT,i40.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i40.EventManager,i40.EventManager,[i40.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i40.ɵDomSharedStylesHost,i40.ɵDomSharedStylesHost,
              [i39.DOCUMENT]),i0.ɵmpd(4608,i40.ɵDomRendererFactory2,i40.ɵDomRendererFactory2,
              [i40.EventManager,i40.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i41.AnimationDriver,
              i42.ɵc,([] as any[])),i0.ɵmpd(5120,i41.ɵAnimationStyleNormalizer,i42.ɵd,
              ([] as any[])),i0.ɵmpd(4608,i41.ɵAnimationEngine,i42.ɵb,[i41.AnimationDriver,
              i41.ɵAnimationStyleNormalizer]),i0.ɵmpd(5120,i0.RendererFactory2,i42.ɵe,
              [i40.ɵDomRendererFactory2,i41.ɵAnimationEngine,i0.NgZone]),i0.ɵmpd(6144,
              i40.ɵSharedStylesHost,(null as any),[i40.ɵDomSharedStylesHost]),i0.ɵmpd(4608,
              i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i40.Meta,i40.Meta,
              [i39.DOCUMENT]),i0.ɵmpd(4608,i40.Title,i40.Title,[i39.DOCUMENT]),i0.ɵmpd(4608,
              i43.DevtoolsExtension,i43.DevtoolsExtension,[i43.REDUX_DEVTOOLS_EXTENSION]),
          i0.ɵmpd(4608,i44.DevtoolsDispatcher,i44.DevtoolsDispatcher,([] as any[])),
          i0.ɵmpd(5120,i45.STORE_DEVTOOLS_CONFIG,i46._createOptions,[i45.INITIAL_OPTIONS]),
          i0.ɵmpd(4608,i44.StoreDevtools,i44.StoreDevtools,[i44.DevtoolsDispatcher,
              i47.Dispatcher,i48.Reducer,i43.DevtoolsExtension,i49.INITIAL_STATE,i45.STORE_DEVTOOLS_CONFIG]),
          i0.ɵmpd(5120,i50.ROUTER_INITIALIZER,i50.ɵi,[i50.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i51.runAfterBootstrapEffects(p0_0,p0_1),p1_0];
              },[i0.Injector,i52.EffectsSubscription,i50.ROUTER_INITIALIZER]),i0.ɵmpd(4608,
              i53.ɵi,i53.ɵi,([] as any[])),i0.ɵmpd(4608,i53.FormBuilder,i53.FormBuilder,
              ([] as any[])),i0.ɵmpd(4608,i54.AnimationBuilder,i42.ɵBrowserAnimationBuilder,
              [i0.RendererFactory2,i40.DOCUMENT]),i0.ɵmpd(5120,i55.LocalData,i56.localDataFactory,
              ([] as any[])),i0.ɵmpd(5120,i57.RemoteData,i56.remoteDataFactory,[i58.Http]),
          i0.ɵmpd(4608,i59.CompleterService,i59.CompleterService,[i55.LocalData,i57.RemoteData]),
          i0.ɵmpd(4608,i60.OrderPipe,i60.OrderPipe,([] as any[])),i0.ɵmpd(4608,i50.NoPreloading,
              i50.NoPreloading,([] as any[])),i0.ɵmpd(6144,i50.PreloadingStrategy,
              (null as any),[i50.NoPreloading]),i0.ɵmpd(135680,i50.RouterPreloader,
              i50.RouterPreloader,[i50.Router,i0.NgModuleFactoryLoader,i0.Compiler,
                  i0.Injector,i50.PreloadingStrategy]),i0.ɵmpd(4608,i50.PreloadAllModules,
              i50.PreloadAllModules,([] as any[])),i0.ɵmpd(4608,i61.DraggableHelper,
              i61.DraggableHelper,([] as any[])),i0.ɵmpd(4608,i62.CalendarEventTitleFormatter,
              i62.CalendarEventTitleFormatter,([] as any[])),i0.ɵmpd(4608,i63.CalendarDateFormatter,
              i63.CalendarDateFormatter,([] as any[])),i0.ɵmpd(4608,i64.CalendarUtils,
              i64.CalendarUtils,([] as any[])),i0.ɵmpd(4608,i65.SignInIffNotAuthorisedGuard,
              i65.SignInIffNotAuthorisedGuard,[i66.Angular2TokenService,i50.Router]),
          i0.ɵmpd(4608,i65.RedirectToMainIfSignedIn,i65.RedirectToMainIfSignedIn,[i66.Angular2TokenService,
              i50.Router]),i0.ɵmpd(4608,i67.ConstantsHelpers,i67.ConstantsHelpers,
              ([] as any[])),i0.ɵmpd(4608,i68.InitialResolver,i68.InitialResolver,
              [i69.ConstantsEffects,i50.Router,i70.Store]),i0.ɵmpd(4608,i71.ContactViewResolver,
              i71.ContactViewResolver,[i72.ContactEffects,i73.MatrixClassEffects,i50.Router,
                  i70.Store]),i0.ɵmpd(4608,i74.EnquiryViewResolver,i74.EnquiryViewResolver,
              [i70.Store,i75.EnquiryEffects]),i0.ɵmpd(4608,i76.ClassManagerViewResolver,
              i76.ClassManagerViewResolver,[i73.MatrixClassEffects,i50.Router,i70.Store]),
          i0.ɵmpd(4608,i77.ClassViewResolver,i77.ClassViewResolver,[i70.Store,i78.Actions]),
          i0.ɵmpd(4608,i79.EnrolmentTimetableViewResolver,i79.EnrolmentTimetableViewResolver,
              [i72.ContactEffects,i70.Store]),i0.ɵmpd(4608,i80.WorkshopsViewResolver,
              i80.WorkshopsViewResolver,[i78.Actions,i70.Store]),i0.ɵmpd(4608,i81.InternalEventViewResolver,
              i81.InternalEventViewResolver,[i70.Store,i78.Actions,i82.EventService]),
          i0.ɵmpd(4608,i83.EventsViewResolver,i83.EventsViewResolver,[i70.Store,i78.Actions]),
          i0.ɵmpd(4608,i84.EventViewResolver,i84.EventViewResolver,[i70.Store,i85.EventEffects,
              i86.UserEffects,i50.Router,i66.Angular2TokenService]),i0.ɵmpd(4608,i87.RolesViewResolver,
              i87.RolesViewResolver,[i88.RoleEffects,i70.Store,i78.Actions]),i0.ɵmpd(4608,
              i89.CalendarViewResolver,i89.CalendarViewResolver,[i70.Store,i78.Actions]),
          i0.ɵmpd(4608,i90.OnlineEnrolmentViewResolver,i90.OnlineEnrolmentViewResolver,
              [i70.Store,i78.Actions,i50.Router,i66.Angular2TokenService]),i0.ɵmpd(4608,
              i91.DirectDebitSummaryViewResolver,i91.DirectDebitSummaryViewResolver,
              [i70.Store,i50.Router,i78.Actions]),i0.ɵmpd(4608,i92.TransactionsByDebtorViewResolver,
              i92.TransactionsByDebtorViewResolver,[i70.Store,i50.Router,i78.Actions]),
          i0.ɵmpd(4608,i93.CommsViewResolver,i93.CommsViewResolver,[i70.Store,i78.Actions]),
          i0.ɵmpd(4608,i94.ModalService,i94.ModalService,([] as any[])),i0.ɵmpd(4608,
              i95.UniqueEmailAsyncValidation,i95.UniqueEmailAsyncValidation,[i96.ContactService]),
          i0.ɵmpd(512,i39.CommonModule,i39.CommonModule,([] as any[])),i0.ɵmpd(1024,
              i0.ErrorHandler,i40.ɵa,([] as any[])),i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i50.ɵb()];
          },([] as any[])),i0.ɵmpd(512,i50.ɵg,i50.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i40.ɵc(p0_0,p0_1),i50.ɵh(p1_0)];
              },[[2,i40.NgProbeToken],[2,i0.NgProbeToken],i50.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i40.BrowserModule,i40.BrowserModule,[[3,i40.BrowserModule]]),
          i0.ɵmpd(512,i49.StoreModule,i49.StoreModule,([] as any[])),i0.ɵmpd(512,i46.StoreDevtoolsModule,
              i46.StoreDevtoolsModule,([] as any[])),i0.ɵmpd(1024,i50.ɵa,i50.ɵd,[[3,
              i50.Router]]),i0.ɵmpd(512,i50.UrlSerializer,i50.DefaultUrlSerializer,
              ([] as any[])),i0.ɵmpd(512,i50.ChildrenOutletContexts,i50.ChildrenOutletContexts,
              ([] as any[])),i0.ɵmpd(256,i50.ROUTER_CONFIGURATION,{},([] as any[])),
          i0.ɵmpd(1024,i39.LocationStrategy,i50.ɵc,[i39.PlatformLocation,[2,i39.APP_BASE_HREF],
              i50.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i39.Location,i39.Location,[i39.LocationStrategy]),
          i0.ɵmpd(512,i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i50.ROUTES,() => {
            return [[{path:'public/events/:id',resolve:{eventViewGuarantee:i84.EventViewResolver},
                component:i97.PurchaseTicketComponent},{path:'online-enrolment',resolve:{onlineEnrolmentViewGuarantee:i90.OnlineEnrolmentViewResolver},
                component:i98.OnlineEnrolmentViewComponent},{path:'',component:i99.MainComponent,
                canActivate:[i65.SignInIffNotAuthorisedGuard],resolve:{initialGuarantee:i68.InitialResolver},
                children:[{path:'contacts/:id/enrolments/new',component:i100.EnrolmentTimetableViewComponent,
                    resolve:{enrolmentFormGuarantee:i79.EnrolmentTimetableViewResolver}},
                    {path:'workshops',resolve:{workshopsGuarantee:i80.WorkshopsViewResolver},
                        component:i101.WorkshopsViewComponent},{path:'calendar',resolve:{calendarViewGuarantee:i89.CalendarViewResolver},
                        component:i102.CalendarViewComponent},{path:'communications',
                        resolve:{commsViewGuarantee:i93.CommsViewResolver},component:i103.CommsViewComponent},
                    {path:'roles',component:i104.RolesViewComponent,resolve:{rolesViewGuarantee:i87.RolesViewResolver}},
                    {path:'admin-area',component:i105.AdminAreaViewComponent},{path:'class-rollover',
                        component:i106.ClassRolloverViewComponent},{path:'enrolment-rollover',
                        component:i107.EnrolmentRolloverViewComponent},{path:'academic-rollover',
                        component:i108.AcademicRolloverViewComponent},{path:'workshops-rollover',
                        component:i109.WorkshopsRolloverViewComponent},{path:'direct-debit-summaries/:id',
                        component:i110.DirectDebitSummaryViewComponent,resolve:{ddsViewGuarantee:i91.DirectDebitSummaryViewResolver}},
                    {path:'direct-debit-summaries/:id/:type',component:i111.TransactionsByDebtorViewComponent,
                        resolve:{transactionsByDebtorViewGuarantee:i92.TransactionsByDebtorViewResolver}}]}]];
          },([] as any[])),i0.ɵmpd(1024,i50.Router,i50.ɵe,[i0.ApplicationRef,i50.UrlSerializer,
              i50.ChildrenOutletContexts,i39.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i50.ROUTES,i50.ROUTER_CONFIGURATION,[2,i50.UrlHandlingStrategy],
              [2,i50.RouteReuseStrategy]]),i0.ɵmpd(512,i50.RouterModule,i50.RouterModule,
              [[2,i50.ɵa],[2,i50.Router]]),i0.ɵmpd(512,i47.Dispatcher,i47.Dispatcher,
              ([] as any[])),i0.ɵmpd(1024,i43.REDUX_DEVTOOLS_EXTENSION,i46._createReduxDevtoolsExtension,
              ([] as any[])),i0.ɵmpd(256,i49._INITIAL_REDUCER,i112.rootReducer,([] as any[])),
          i0.ɵmpd(1024,i49.INITIAL_REDUCER,i49._initialReducerFactory,[i49._INITIAL_REDUCER]),
          i0.ɵmpd(1024,i48.Reducer,i46._createReducerIfExtension,[i43.REDUX_DEVTOOLS_EXTENSION,
              i0.Injector,i49.INITIAL_REDUCER]),i0.ɵmpd(256,i49._INITIAL_STATE,(undefined as any),
              ([] as any[])),i0.ɵmpd(1024,i49.INITIAL_STATE,i49._initialStateFactory,
              [i49._INITIAL_STATE,i49.INITIAL_REDUCER]),i0.ɵmpd(1024,i113.State,i46._createStateIfExtension,
              [i43.REDUX_DEVTOOLS_EXTENSION,i0.Injector,i49.INITIAL_STATE]),i0.ɵmpd(1024,
              i70.Store,i49._storeFactory,[i47.Dispatcher,i48.Reducer,i113.State]),
          i0.ɵmpd(512,i78.Actions,i78.Actions,[i47.Dispatcher]),i0.ɵmpd(512,i58.BrowserXhr,
              i58.BrowserXhr,([] as any[])),i0.ɵmpd(512,i58.ResponseOptions,i58.BaseResponseOptions,
              ([] as any[])),i0.ɵmpd(1024,i58.XSRFStrategy,i58.ɵb,([] as any[])),i0.ɵmpd(512,
              i58.XHRBackend,i58.XHRBackend,[i58.BrowserXhr,i58.ResponseOptions,i58.XSRFStrategy]),
          i0.ɵmpd(512,i58.RequestOptions,i58.BaseRequestOptions,([] as any[])),i0.ɵmpd(1024,
              i58.Http,i58.ɵc,[i58.XHRBackend,i58.RequestOptions]),i0.ɵmpd(1024,i50.ActivatedRoute,
              i50.ɵf,[i50.Router]),i0.ɵmpd(512,i66.Angular2TokenService,i66.Angular2TokenService,
              [i58.Http,[2,i50.ActivatedRoute],[2,i50.Router]]),i0.ɵmpd(512,i114.ConstantService,
              i114.ConstantService,[i66.Angular2TokenService,i70.Store]),i0.ɵmpd(512,
              i69.ConstantsEffects,i69.ConstantsEffects,[i78.Actions,i114.ConstantService]),
          i0.ɵmpd(512,i115.ActionCableService,i115.ActionCableService,([] as any[])),
          i0.ɵmpd(512,i96.ContactService,i96.ContactService,[i66.Angular2TokenService,
              i115.ActionCableService,i70.Store]),i0.ɵmpd(512,i116.RoleService,i116.RoleService,
              [i66.Angular2TokenService,i70.Store]),i0.ɵmpd(512,i86.UserEffects,i86.UserEffects,
              [i78.Actions,i96.ContactService,i116.RoleService,i66.Angular2TokenService]),
          i0.ɵmpd(512,i117.EnrolmentService,i117.EnrolmentService,[i66.Angular2TokenService,
              i115.ActionCableService,i70.Store]),i0.ɵmpd(512,i72.ContactEffects,i72.ContactEffects,
              [i78.Actions,i96.ContactService,i117.EnrolmentService]),i0.ɵmpd(512,
              i118.EnquiryService,i118.EnquiryService,[i66.Angular2TokenService,i115.ActionCableService,
                  i70.Store]),i0.ɵmpd(512,i119.MatrixClassService,i119.MatrixClassService,
              [i66.Angular2TokenService,i70.Store]),i0.ɵmpd(512,i75.EnquiryEffects,
              i75.EnquiryEffects,[i78.Actions,i118.EnquiryService,i119.MatrixClassService]),
          i0.ɵmpd(512,i73.MatrixClassEffects,i73.MatrixClassEffects,[i78.Actions,i119.MatrixClassService]),
          i0.ɵmpd(512,i120.EnrolmentEffects,i120.EnrolmentEffects,[i78.Actions,i117.EnrolmentService,
              i119.MatrixClassService,i96.ContactService]),i0.ɵmpd(512,i121.TermService,
              i121.TermService,[i66.Angular2TokenService,i115.ActionCableService,i70.Store]),
          i0.ɵmpd(512,i122.PublicHolidayService,i122.PublicHolidayService,[i66.Angular2TokenService,
              i115.ActionCableService,i70.Store]),i0.ɵmpd(512,i123.CalendarEffects,
              i123.CalendarEffects,[i78.Actions,i121.TermService,i122.PublicHolidayService]),
          i0.ɵmpd(512,i124.WorkshopService,i124.WorkshopService,[i66.Angular2TokenService]),
          i0.ɵmpd(512,i125.WorkshopEffects,i125.WorkshopEffects,[i78.Actions,i124.WorkshopService]),
          i0.ɵmpd(512,i126.TutorAllocationService,i126.TutorAllocationService,[i66.Angular2TokenService]),
          i0.ɵmpd(512,i127.TutorAllocationEffects,i127.TutorAllocationEffects,[i78.Actions,
              i126.TutorAllocationService]),i0.ɵmpd(512,i128.BookingService,i128.BookingService,
              [i66.Angular2TokenService]),i0.ɵmpd(512,i129.BookingEffects,i129.BookingEffects,
              [i78.Actions,i128.BookingService,i96.ContactService]),i0.ɵmpd(512,i82.EventService,
              i82.EventService,[i66.Angular2TokenService]),i0.ɵmpd(512,i130.TicketService,
              i130.TicketService,[i66.Angular2TokenService]),i0.ɵmpd(512,i85.EventEffects,
              i85.EventEffects,[i78.Actions,i82.EventService,i130.TicketService]),
          i0.ɵmpd(512,i88.RoleEffects,i88.RoleEffects,[i78.Actions,i116.RoleService]),
          i0.ɵmpd(512,i131.TransactionService,i131.TransactionService,[i66.Angular2TokenService,
              i70.Store]),i0.ɵmpd(512,i132.TransactionEffects,i132.TransactionEffects,
              [i78.Actions,i131.TransactionService,i96.ContactService]),i0.ɵmpd(512,
              i133.CommService,i133.CommService,[i66.Angular2TokenService]),i0.ɵmpd(512,
              i134.CommEffects,i134.CommEffects,[i78.Actions,i133.CommService]),i0.ɵmpd(1024,
              i52.effects,(p0_0:any,p1_0:any,p2_0:any,p3_0:any,p4_0:any,p5_0:any,p6_0:any,
                  p7_0:any,p8_0:any,p9_0:any,p10_0:any,p11_0:any,p12_0:any,p13_0:any) => {
                return [p0_0,p1_0,p2_0,p3_0,p4_0,p5_0,p6_0,p7_0,p8_0,p9_0,p10_0,p11_0,
                    p12_0,p13_0];
              },[i69.ConstantsEffects,i86.UserEffects,i72.ContactEffects,i75.EnquiryEffects,
                  i73.MatrixClassEffects,i120.EnrolmentEffects,i123.CalendarEffects,
                  i125.WorkshopEffects,i127.TutorAllocationEffects,i129.BookingEffects,
                  i85.EventEffects,i88.RoleEffects,i132.TransactionEffects,i134.CommEffects]),
          i0.ɵmpd(131584,i52.EffectsSubscription,i52.EffectsSubscription,[i70.Store,
              [3,i52.EffectsSubscription],[2,i52.effects]]),i0.ɵmpd(512,i135.EffectsModule,
              i135.EffectsModule,[i52.EffectsSubscription]),i0.ɵmpd(512,i53.ɵba,i53.ɵba,
              ([] as any[])),i0.ɵmpd(512,i53.FormsModule,i53.FormsModule,([] as any[])),
          i0.ɵmpd(512,i53.ReactiveFormsModule,i53.ReactiveFormsModule,([] as any[])),
          i0.ɵmpd(512,i58.HttpModule,i58.HttpModule,([] as any[])),i0.ɵmpd(512,i42.BrowserAnimationsModule,
              i42.BrowserAnimationsModule,([] as any[])),i0.ɵmpd(512,i136.ResizableModule,
              i136.ResizableModule,([] as any[])),i0.ɵmpd(512,i137.DragAndDropModule,
              i137.DragAndDropModule,([] as any[])),i0.ɵmpd(512,i138.CalendarModule,
              i138.CalendarModule,([] as any[])),i0.ɵmpd(512,i139.Ng2CompleterModule,
              i139.Ng2CompleterModule,([] as any[])),i0.ɵmpd(512,i140.DateValueAccessorModule,
              i140.DateValueAccessorModule,([] as any[])),i0.ɵmpd(512,i60.OrderModule,
              i60.OrderModule,([] as any[])),i0.ɵmpd(512,i141.ClickOutsideModule,i141.ClickOutsideModule,
              ([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[])),
          i0.ɵmpd(256,i45.INITIAL_OPTIONS,{maxAge:30},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/app.module.ngfactory.ts